import '../src/assets/customIcons.css'
import '../src/assets/materialdesignicons.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './helpers/i18n'

Vue.config.productionTip = false

export const eventBus = new Vue()

new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
